/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

const GRAFANA = 'http://10.14.0.22:3000';
const DASHBOARD = '/d/L_d2i-lWz/singleflowmetrics';
const ORGID = '?orgId=1';

/** Opens the grafana dashboard on flow metrics for the given flow in a new tab */
export default function openFlowMetrics(flowname: string) {
  const url = `${GRAFANA + DASHBOARD + ORGID}&var-Flow=${flowname}`;
  window.open(url, '_blank');
}
